'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripEtalageV1Directive.$inject = ['ApiService'];


var _ = {
    each: _each3.default
};

var _module = angular.module('cb.strips.cb-strip-etalage-v1.cbStripEtalageV1', []);

_module.directive('cbStripEtalageV1', cbStripEtalageV1Directive);

exports.default = _module;


function cbStripEtalageV1Directive(ApiService) {
    return {
        restrict: 'A',
        scope: true,
        controller: 'cbStripEtalageV1Controller',
        controllerAs: 'etalage',
        link: cbStripEtalageV1Link
    };

    function addEtalageNavCbFunctions(element) {
        var _gettersAndSetters = addEtalageNavGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        ApiService.attach({
            'etalage-nav': gettersAndSetters
        });
    }

    function cbStripEtalageV1Link(scope, element, attr) {

        angular.forEach(element.find('.nav-list > li'), function (nav) {
            addEtalageNavCbFunctions(nav);
        });

        _.each(element.find('.content-block--clickable'), function (contentBlockElement) {
            contentBlockElement = angular.element(contentBlockElement);
            var _gettersAndSetters = addEtalageCardGettersAndSetters(contentBlockElement);
            var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

            ApiService.attach({
                'etalage-card': gettersAndSetters
            });
        });

        _.each(element.find('.pill-list__item--filter'), function (filterElement) {
            filterElement = angular.element(filterElement);
            var _gettersAndSetters = addEtalagePillGettersAndSetters(filterElement);
            var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

            ApiService.attach({
                'etalage-pill': gettersAndSetters
            });
        });
    }

    function addEtalagePillGettersAndSetters(element) {
        var pill = {};

        Object.defineProperty(pill, 'selectPill', {
            get: function get() {
                return element.text();
            },
            set: function set() {
                // Math to get needed pixels to center selected element on horizontal scrollbar
                var pillList = element.parent();
                var pillListItems = pillList.find('.pill-list__item');

                var pillListWidth = pillList.width();
                var pillListFullWidth = element.outerWidth(true);
                var elementIndex = element.index();

                var pixelsLeftTarget = 0;
                for (var i = 0; i < elementIndex; i++) {
                    pixelsLeftTarget += $(pillListItems[i]).outerWidth(true);
                }

                var pixelsRightTarget = (pillListWidth - pillListFullWidth) / 2;
                var pixelsToTarget = pixelsLeftTarget - pixelsRightTarget;

                // Scroll horizontal to selected element and click it
                pillList.scrollLeft(Math.max(0, pixelsToTarget));
                angular.element(element).click();
            }
        });
        return pill;
    }

    function addEtalageNavGettersAndSetters(element) {
        var nav = {};

        Object.defineProperty(nav, 'link', {
            get: function get() {
                return angular.element(element).find('a').text();
            },
            set: function set(newValue) {
                if (newValue.text) {
                    angular.element(element).find('a').text(newValue.text);
                }
                if (newValue.href) {
                    angular.element(element).find('a').attr('href', newValue.href);
                }
                if (newValue.icon) {
                    var icon = angular.element(element).find('.icon');
                    (0, _from2.default)(icon[0].classList).filter(function (className) {
                        return className.search(/icon--(?!(lg))[a-zA-Z]*/gi) === 0;
                    }).forEach(function (className) {
                        icon.removeClass(className);
                    });
                    icon.addClass('icon--' + newValue.icon);
                }
            }
        });

        return nav;
    }

    function addEtalageCardGettersAndSetters(element) {
        var card = {};

        Object.defineProperty(card, 'imageDefault', {
            get: function get() {
                return element.find('.content-block__image-img').attr('src');
            },
            set: function set(newValue) {
                element.find('.content-block__image-img').attr('src', newValue);
            }
        });

        Object.defineProperty(card, 'imageSmall', {
            get: function get() {
                return $(element.find('picture source')[2]).attr('srcset');
            },
            set: function set(newValue) {
                $(element.find('picture source')[2]).attr('srcset', newValue);
            }
        });

        Object.defineProperty(card, 'imageMedium', {
            get: function get() {
                return $(element.find('picture source')[1]).attr('srcset');
            },
            set: function set(newValue) {
                $(element.find('picture source')[1]).attr('srcset', newValue);
            }
        });

        Object.defineProperty(card, 'imageLarge', {
            get: function get() {
                return $(element.find('picture source')[0]).attr('srcset');
            },
            set: function set(newValue) {
                $(element.find('picture source')[0]).attr('srcset', newValue);
            }
        });

        Object.defineProperty(card, 'imageAlt', {
            get: function get() {
                return element.find('.content-block__image-img').attr('alt');
            },
            set: function set(newValue) {
                element.find('.content-block__image-img').attr('alt', newValue);
            }
        });

        Object.defineProperty(card, 'title', {
            get: function get() {
                return angular.element(element.find('.heading-strip-subtitle')[0]).html();
            },
            set: function set(newValue) {
                angular.element(element.find('.heading-strip-subtitle')[0]).html(newValue);
            }
        });

        Object.defineProperty(card, 'text', {
            get: function get() {
                return element.find('.text').html();
            },
            set: function set(newValue) {
                element.find('.text').html(newValue);
            }
        });

        Object.defineProperty(card, 'link', {
            get: function get() {
                return angular.element(element).find('a').attr('href');
            },
            set: function set(newValue) {
                angular.element(element).find('a').attr('href', newValue);
            }
        });

        Object.defineProperty(card, 'spotTitle', {
            get: function get() {
                return element.find('.spot__price').html();
            },
            set: function set(newValue) {
                element.find('.spot__price').html(newValue);
            }
        });

        Object.defineProperty(card, 'spotText', {
            get: function get() {
                return element.find('.u-text-small').html();
            },
            set: function set(newValue) {
                element.find('.u-text-small').html(newValue);
            }
        });

        return card;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/etalage-v1/etalage.directive.js
// module id = 940
// module chunks = 1